import { AbstractControl, Validators } from "@angular/forms";

/** Valor do caractere conforme spec Receita Federal: dígito → valor numérico; letra A-Z → ASCII - 48 */
function charValue(ch: string): number {
    const code = ch.toUpperCase().charCodeAt(0);
    if (code >= 48 && code <= 57) return code - 48; // '0'-'9'
    if (code >= 65 && code <= 90) return code - 48; // 'A'-'Z': ASCII - 48
    return -1;
}

/** Remove máscara, espaços (início/fim/colados) e normaliza para maiúsculas, preservando letras A-Z */
export function unmaskCnpj(value: string): string {
    return (value ?? '').trim().replace(/\s+/g, '').replace(/[.\-/]/g, '').toUpperCase();
}

/** Valida formato + dígitos verificadores. */
export function isCnpjValido(cnpjSemMascara: string): boolean {
    if (cnpjSemMascara.length !== 14) return false;

    // Dígitos verificadores (posições 12 e 13) devem ser numéricos
    if (!/^\d$/.test(cnpjSemMascara[12]) || !/^\d$/.test(cnpjSemMascara[13]))
        return false;

    // Rejeita todos os caracteres iguais
    if (/^(.)\1*$/.test(cnpjSemMascara)) return false;

    // Valida caracteres válidos: A-Z ou 0-9
    if (!/^[A-Z0-9]{14}$/.test(cnpjSemMascara)) return false;

    // Pesos conforme spec Receita Federal
    const weights1 = [5,4,3,2,9,8,7,6,5,4,3,2];
    const weights2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];

    let sum1 = 0;
    for (let i = 0; i < 12; i++) sum1 += charValue(cnpjSemMascara[i]) * weights1[i];
    const d1 = sum1 % 11 < 2 ? 0 : 11 - (sum1 % 11);
    if (d1 !== parseInt(cnpjSemMascara[12])) return false;

    let sum2 = 0;
    for (let i = 0; i < 13; i++) sum2 += charValue(cnpjSemMascara[i]) * weights2[i];
    const d2 = sum2 % 11 < 2 ? 0 : 11 - (sum2 % 11);
    if (d2 !== parseInt(cnpjSemMascara[13])) return false;

    return true;
}

export class CnpjValidator {
    static isValid(control: AbstractControl): { [key: string]: any } | null {
        if (control.value) {
            const cnpj = unmaskCnpj(control.value);
            const isAlphanumeric = /[A-Z]/.test(cnpj);
            const error = { "invalid-cnpj": { alphanumeric: isAlphanumeric } };

            return isCnpjValido(cnpj) ? null : error;
        } else {
            if (!control.hasValidator(Validators.required)) { return {}; }
            return { "invalid-cnpj": { alphanumeric: false } };
        }
    }
}
